import { useNavigate } from "react-router-dom";
import {
  NoItemsLeftInTable,
  convertTo12HourFormat,
} from "../../../../../helpers/helpers";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingSkeleton from "../../../../loader/TableLoader";
import { Tooltip as ReactTooltip } from "react-tooltip";

function SeviceLotForSelectId({
  setCheckedValue,
  checkedValue,
  setRemainUncheck,
}) {
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [offerDataValue, setOfferDataValue] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // State to manage header checkbox
  const [checkedRows, setCheckedRows] = useState({});
  const [totalUncheckedItems, setTotalUncheckedItems] = useState(0);
  const [mouseEnter, setMouseEnter] = useState(false);
  const { organization, loadings } = useSelector(
    (pre) => pre?.organizationDetails
  );
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );

  useEffect(() => {
    if (singleAuctionData) {
      const updatedAuctionData = singleAuctionData?.offers?.map((offer) => ({
        ...offer,
        status: false,
      }));
      setOfferDataValue(updatedAuctionData);
    }
  }, [singleAuctionData]);

  // Function to toggle individual row checkbox
  const handleRowToggle = (id) => {
    const item = offerDataValue.find((item) => item._id === id);
    if (item.deposited) {
      return; // Prevent toggling if the item is deposited
    }

    setCheckedRows((prevCheckedRows) => {
      const newCheckedRows = {
        ...prevCheckedRows,
        [id]: !prevCheckedRows[id],
      };

      // Update remainUncheck state
      if (!prevCheckedRows[id]) {
        setRemainUncheck((prev) =>
          prev.filter((uncheckedItem) => uncheckedItem._id !== id)
        );
      } else {
        setRemainUncheck((prev) => [...prev, item]);
      }

      return newCheckedRows;
    });

    // Check if checkbox is true and add the object to checkedValue array
    if (!checkedRows[id]) {
      setCheckedValue([
        ...checkedValue,
        offerDataValue.find((item) => item._id === id),
      ]);
    } else {
      setCheckedValue(checkedValue.filter((item) => item._id !== id));
    }
  };

  //  toggle header checkbox
  const handleHeaderToggle = () => {
    setSelectAll(!selectAll);

    const newCheckedRows = {};
    const newRemainUncheck = [];

    offerDataValue.forEach((item) => {
      const pcbdocument =
        organization?.PCBVerified === true
          ? true
          : item.requiresPCBCertificate === true
          ? false
          : true;
      if (!item.deposited && pcbdocument) {
        newCheckedRows[item._id] = !selectAll;
        if (selectAll) {
          newRemainUncheck.push(item);
        }
      }
    });

    setCheckedRows(newCheckedRows);

    if (!selectAll) {
      setCheckedValue(
        offerDataValue.filter(
          (item) =>
            !checkedRows[item._id] &&
            !item.deposited &&
            (organization?.PCBVerified === true
              ? true
              : item.requiresPCBCertificate === true
              ? false
              : true)
        )
      );
    } else {
      setCheckedValue([]);
    }

    setRemainUncheck(newRemainUncheck);
  };

  const verifyPBCtraderFunction = (idx) => {
    navigate("/documents/showDetails");
  };

  useEffect(() => {
    if (checkedValue?.length === 0) {
      setSelectAll(false);
      setCheckedRows({});
    } else if (checkedValue?.length === totalUncheckedItems) {
      setSelectAll(true);
    }
  }, [checkedValue, totalUncheckedItems]);

  useEffect(() => {
    const uncheckedItems = offerDataValue?.filter(
      (item) =>
        !item?.deposited &&
        (organization?.PCBVerified
          ? true
          : item.requiresPCBCertificate
          ? false
          : true)
    );

    setRemainUncheck(uncheckedItems);
    setTotalUncheckedItems(uncheckedItems?.length);
  }, [offerDataValue, setRemainUncheck, organization]);

  return (
    <>
      {loading || loadings ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "Lots ID",
              "Service Title",
              "Lot Time",
              "Category",
              "EMD Amount (Rs.)",
            ]}
          />
        </div>
      ) : (
        <>
          <div className={`${!isTablet && " table-container-style "}`}>
            <table
              className={`responsive-table centered pointer ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>
                    <span
                      className="material-icons-outlined pointer checkToggle"
                      onClick={handleHeaderToggle} // Toggle header checkbox
                      style={{
                        paddingTop: !isTablet ? "5px" : "unset",
                      }}
                    >
                      {selectAll && checkedValue?.length === totalUncheckedItems
                        ? "check_box"
                        : "check_box_outline_blank"}
                    </span>
                  </th>
                  <th>Lots No</th>
                  <th>Service Title</th>
                  <th>Lots Time</th>
                  <th>Category/Sub-Category</th>
                  <th>Lifting Period</th>
                  <th>EMD Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {offerDataValue?.map((item, index) => (
                  <tr
                    data-tooltip-id={
                      item?.deposited ? `tooltip-${item._id}` : undefined
                    }
                    key={item?._id}
                    className={`${
                      item.requiresPCBCertificate ? "pcb-required" : ""
                    } ${
                      item?.deposited ? "green accent-1 tooltip-container" : ""
                    }`}
                    onMouseEnter={() =>
                      item.requiresPCBCertificate && setMouseEnter(item._id)
                    }
                    onMouseLeave={() =>
                      item.requiresPCBCertificate && setMouseEnter(null)
                    }
                  >
                    {item.requiresPCBCertificate &&
                    mouseEnter === item._id &&
                    !organization?.PCBVerified ? (
                      <td colSpan={7}>
                        {" "}
                        Only for PCB Traders
                        <span
                          className="light-blue-text text-accent-3 pointer underline"
                          style={{ marginLeft: "5px" }}
                          onClick={() => verifyPBCtraderFunction(index)}
                        >
                          Verify Now
                        </span>
                      </td>
                    ) : (
                      <>
                        <td style={{ width: "100px" }}>
                          {item.requiresPCBCertificate &&
                          !organization?.PCBVerified ? (
                            <span
                              className="material-icons-outlined disabled checkToggle"
                              style={{
                                paddingTop: !isTablet ? "5px" : "unset",
                              }}
                            >
                              check_box_outline_blank
                            </span>
                          ) : (
                            <>
                              {item?.deposited ? (
                                <span className="material-icons-outlined">
                                  done
                                </span>
                              ) : (
                                <span
                                  className="material-icons-outlined pointer checkToggle"
                                  onClick={() => handleRowToggle(item._id)}
                                  style={{
                                    paddingTop: !isTablet ? "5px" : "unset",
                                  }}
                                >
                                  {checkedRows[item._id]
                                    ? "check_box"
                                    : "check_box_outline_blank"}
                                </span>
                              )}
                            </>
                          )}
                        </td>
                        <td>{index + 1}</td>
                        <td>{item?.serviceDetails?.title}</td>
                        <td>{`${convertTo12HourFormat(
                          item?.offerSchedule?.startTimeAndDate
                        )} - ${convertTo12HourFormat(
                          item?.offerSchedule?.endTimeAndDate
                        )}`}</td>
                        <td>{`${item?.serviceDetails?.category} / ${item?.serviceDetails?.subCategory}`}</td>
                        <td>{item?.liftingPeriod}</td>
                        <td>{item?.EMDAmount}</td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {offerDataValue?.length === 0 && <NoItemsLeftInTable />}
          </div>
        </>
      )}
      {offerDataValue?.map(
        (item) =>
          item?.deposited && (
            <ReactTooltip
              key={item._id}
              id={`tooltip-${item._id}`}
              place="top"
              content="EMD already paid for these lots."
            />
          )
      )}
    </>
  );
}

export default SeviceLotForSelectId;
